import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Button, Collapse, Nav, Navbar } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import './Sidebar.scss';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';

/**
 * Sidebar à gauche dans le dashboard. Cliquer sur les liens update
 * la partie de droite pour nous afficher un tableau d'entité.
 * @param param0 le contenu à droite de la sidebar
 * @returns une sidebar
 */
export default function Sidebar({ children }: { children: ReactNode }): ReactElement {
    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };

    const hrefs: string[] = [
        '/dashboard/ententes',
        '/dashboard/fournisseurs',
        '/dashboard/activites',
        '/dashboard/produits',
        '/dashboard/contacts',
        '/dashboard/clients',
        '/dashboard/centres-service-scolaire',
        '/dashboard/calendrier-scolaire',
        '/dashboard/lieux',
        '/dashboard/etiquettes',
        '/dashboard/options',
        '/dashboard/logs',
        '/dashboard/modeles-horaire',
        '/dashboard/modeles-courriel',
    ];
    const linkName: string[] = [
        'Ententes',
        'Fournisseurs',
        'Activités',
        'Produits',
        'Contacts',
        'Clients',
        'Centre de Serv. Scol.',
        'Calendrier Scolaire',
        'Lieux',
        'Étiquettes',
        'Options',
        'Logs',
        "Modèles d'horaire",
        'Modèles de courriel',
    ];
    const location = useLocation();

    const [activeLinks, setActiveLinks] = useState<boolean[]>(() =>
        hrefs.map((href) => location.pathname.startsWith(href)),
    );

    useEffect(() => {
        const nextActiveLinks: boolean[] = hrefs.map((href) => location.pathname.startsWith(href));
        setActiveLinks(nextActiveLinks);
    }, [location]);

    /**
     * Liens de la sidebar. Le as pour utiliser la navigation react-router-dom
     * et ne pas rafraichir toute la page. Le active sert à indiquer l'onglet
     * présent même lorsqu'on est dans un formulaire.
     * @returns la liste des liens de la sidebar
     */
    function NavLinks(): ReactElement[] {
        return hrefs.map((href, i) => (
            <Nav.Link as={Link} to={href} active={activeLinks[i]} key={i}>
                {linkName[i]}
            </Nav.Link>
        ));
    }

    const cssNavbar: string = [
        'position-sticky',
        'flex-column',
        'align-items-start',
        'px-3',
        'fixed-top',
        'vh-100',
        'navbar-custom',
    ].join(' ');

    const buttonCollapsed: string = ['position-sticky', 'flex-column', 'align-items-start', 'px-3'].join(' ');

    return (
        <div className="d-flex">
            {collapsed ? (
                <Button
                    variant="d-flex"
                    className={cssNavbar}
                    onClick={toggleCollapse}
                    aria-controls="sidebar-collapse"
                    aria-expanded={collapsed}
                    style={{
                        backgroundColor: '#343A40',
                        borderRadius: '0px',
                    }}
                >
                    <BiArrowFromLeft style={{ color: 'white' }} />
                </Button>
            ) : null}
            <Collapse in={!collapsed}>
                <Navbar id="sidebar-collapse" className={cssNavbar} bg="dark" variant="dark">
                    <Navbar.Brand as={Link} to="/activites">
                        Solution Animation
                    </Navbar.Brand>
                    <Nav className="flex-column">{NavLinks()}</Nav>
                    <Nav className="flex-column">
                        <Button
                            className={buttonCollapsed}
                            variant="d-flex"
                            onClick={toggleCollapse}
                            aria-controls="sidebar-collapse"
                            aria-expanded={collapsed}
                            style={{
                                backgroundColor: '#343A40',
                                borderRadius: '0px',
                            }}
                        >
                            {collapsed ? (
                                <BiArrowFromLeft style={{ color: 'white' }} />
                            ) : (
                                <BiArrowFromRight style={{ color: 'white' }} />
                            )}
                        </Button>
                    </Nav>
                </Navbar>
            </Collapse>
            <div className="d-flex flex-column flex-grow-1">{children}</div>
        </div>
    );
}
